import React from "react";
import { Link } from "react-router-dom";
import "./vista-404.view.scss";
class Vista404 extends React.Component {
  render() {
    return (
      <div className="view-404 card-sinia">
        <div className="card-body">
          <h5 className="card-title">Pagina no encontrada!</h5>
          <p className="card-text">
            Lo sentimos la página solicitada no existe, probablemente fue movida
            o eliminada, verifique que la dirección sea la correcta.
          </p>
          <Link to="./" className="btn btn-link">
            Ir al inicio
          </Link>
        </div>
      </div>
    );
  }
}
export default Vista404;
